export const TITLE = {
  create: 'Criar segmento',
  edit: 'Editar segmento',
};

export const CONFIRM = {
  create: 'Criar segmento',
  edit: 'Salvar alterações',
};

export const SEGMENT_TYPE_LIST = [{ label: 'Redes', value: 'redes' }];
